import React from 'react';
import { useIntl } from 'react-intl';
import {
  FieldArrayRenderProps,
  useField,
} from 'formik';

import * as types from 'hellospa/page/prep-and-send/data/types';
import styles from '../index.scss';
import messages from './intl';
import PencilEditIcon from './icons/pencil-edit';
import TrashcanIcon from './icons/trashcan';

type Props = {
  createAutoGenerated: () => types.Attachment,
  formikHelpers: FieldArrayRenderProps,
};

const List = ({ createAutoGenerated, formikHelpers }: Props) => {
  const intl = useIntl();

  const [attachmentsField] = useField<types.Attachment[]>('attachments');
  const [currentField, , currentHelper] = useField<types.Attachment>('current');

  if (!attachmentsField.value.length) {
    return null;
  }

  const edit = (e: React.FormEvent<SVGSVGElement>) => {
    const index = Number(e.currentTarget.id);
    currentHelper.setValue(attachmentsField.value[index]);
  };

  const remove = (e: React.FormEvent<SVGSVGElement>) => {
    const index = Number(e.currentTarget.id);

    // Deleting currently selected record
    if (currentField.value.id === attachmentsField.value[index].id) {
      currentHelper.setValue(createAutoGenerated());
    }

    formikHelpers.remove(index);
  };

  return (
    <React.Fragment>
      <h3 className="l-bold">
        {intl.formatMessage(messages.modalTitle)}
      </h3>
      <hr />

      <div role="attachments-list" data-qa-ref="recipients.attachments.list">
        {attachmentsField.value.map((attachment, index) => (
          <div
            key={`recipients.attachments.list.${index}`}
            className={styles.attachmentRow}
          >
            <span>{attachment.name} {attachment.required && '*'}</span>
            {attachment.id !== currentField.value.id && (
              <PencilEditIcon
                id={`${index}`}
                role="attachment-edit"
                data-qa-ref={`recipients.attachments.list.${index}.edit`}
                onClick={edit} />
            )}
            <TrashcanIcon
              id={`${index}`}
              role="attachment-delete"
              data-qa-ref={`recipients.attachments.list.${index}.delete`}
              onClick={remove} />
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

export default List;
